import { render, staticRenderFns } from "./ChimeNetworkDetailModal.vue?vue&type=template&id=c8001582&scoped=true&"
import script from "./ChimeNetworkDetailModal.vue?vue&type=script&lang=js&"
export * from "./ChimeNetworkDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ChimeNetworkDetailModal.vue?vue&type=style&index=0&id=c8001582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8001582",
  null
  
)

export default component.exports